/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import '@tiptap/extension-text-style';
import { Extension } from '@tiptap/core';

type FontSizeOptions = {
  types: string[];
  defaultSize: string;
};

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fontStyle: {
      setFontStyle: (style: string) => ReturnType;
    };
  }
}

export const CustomizedFontStyle = Extension.create<FontSizeOptions>({
  name: 'fontStyle',

  addOptions() {
    return {
      types: ['textStyle'],
      defaultSize: 'normal',
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontStyle: {
            default: null,
            parseHTML: (element) => {
              const style = element.style.fontStyle;

              if (!style || style === 'undefined' || style.includes('undefined')) {
                return null;
              }

              return style.replace(/['"]+/g, '');
            },
            renderHTML: (attributes) => {
              const style = attributes.fontStyle;
              if (!style || style === 'undefined' || style.includes('undefined')) {
                return {};
              }

              return {
                style: `font-style: ${style}`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontStyle:
        (fontStyle: string) =>
        ({ chain }) => {
          return chain().setMark('textStyle', { fontStyle }).run();
        },
    };
  },
});
